/**
 * Tiny string templating for copy in `@/content/site`.
 *
 * @module
 */

/**
 * Replaces `{key}` placeholders in a copy template. Unknown keys are left as they are, so a
 * missing value shows up in review instead of rendering as an empty gap.
 *
 * @example
 * fill('New identity for {name}.', { name: 'Sharma Sweets' }) // 'New identity for Sharma Sweets.'
 */
export function fill(template: string, values: Readonly<Record<string, string>>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) => values[key] ?? match)
}
